<template>
    <div class="login-bg">
        <w-app
            id="app"
            class="justify-space-between basis-zero justify-center login-bg"
        >
            <w-notification
                v-if="$page.props.flash.success"
                success
                transition="bounce"
                absolute
                plain
                round
                timeout="4000"
                @close="$page.props.flash.success = ''"
            >
                {{ $page.props.flash.success }}
            </w-notification>

            <w-notification
                v-if="$page.props.flash.notifyerror"
                error
                transition="bounce"
                absolute
                plain
                round
                timeout="2000"
                @close="$page.props.flash.notifyerror = ''"
            >
                {{ $page.props.flash.notifyerror }}
            </w-notification>
            <w-flex wrap class="login-ihasil">
                <div class="xs6 pa1 login-left">
                    <div class="py3 login-main">
                        <div class="login-header">i-HASIL</div>
                        <div class="login-2nd-header">Log Masuk</div>

                        <!-- -->
                        <main class="grow mt5">
                            <w-card class="zloginbox">
                                <w-alert
                                    class="my0 mb2 text-light"
                                    v-if="$page.props.flash.errors"
                                    error
                                    transition="bounce"
                                    plain
                                    round
                                    no-border
                                    dismiss
                                >
                                    {{ $page.props.flash.errors }}
                                </w-alert>
                                <template #buttons />

                                <w-form @validate="attemp">
                                    <z-input
                                        outline
                                        label="ID Pengguna"
                                        placeholder="Sila Masukkan ID Pengguna"
                                        type="email"
                                        name="email"
                                        v-model="form.email"
                                        :validators="[
                                            validators.required,
                                            validators.email,
                                        ]"
                                    />
                                    <div class="spacer"></div>
                                    <z-input
                                        outline
                                        label="Kata Laluan"
                                        class="mt5"
                                        placeholder="Sila Masukkan Kata Laluan"
                                        :type="isPassword ? 'password' : 'text'"
                                        :inner-icon-right="
                                            isPassword
                                                ? 'fal fa-eye-slash'
                                                : 'fal fa-eye'
                                        "
                                        @click:inner-icon-right="
                                            isPassword = !isPassword
                                        "
                                        name="password"
                                        v-model="form.password"
                                        :validators="[validators.required]"
                                    />

                                    <div class="mt5 mb5"></div>

                                    <w-flex justify-end align-end>
                                        <!-- <div class="xs6 w-list__item-label--disabled">
                                      <w-checkbox>Ingat Saya</w-checkbox>
                                  </div> -->
                                        <div class="xs6 text-right">
                                            <inertia-link
                                                :href="
                                                    $route('forget-password')
                                                "
                                                ><w-icon
                                                    >fal
                                                    fa-question-circle</w-icon
                                                >
                                                Lupa Kata Laluan?</inertia-link
                                            >
                                        </div>
                                    </w-flex>
                                    <w-flex justify-center align-center class="mt5">
                                        <w-button
                                            class="my2 btn-ihasil-login grow"
                                            type="submit"
                                            @click="loginMode = 'db'"
                                        >
                                            <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon>
                                            Log Masuk
                                        </w-button>
                                    </w-flex>
                                    <!-- SSO
                                    <w-flex justify-center align-center class="mt2">
                                        <w-button
                                            class="my2 btn-ihasil-login grow"
                                            type="submit"
                                            @click="loginMode = 'sso'"
                                        >
                                            <w-icon class="mr2" xs>fal fa-shield-alt</w-icon>
                                            Log Masuk dengan SSO
                                        </w-button>
                                    </w-flex>
                                    -->
                                    <div class="login-divider"></div>
                                    <w-flex justify-center align-center class="mt2">
                                        <a
                                            :href="$route('login.mydigitalid.redirect')"
                                            class="btn-mydigitalid grow"
                                        >
                                            <span>Log Masuk dengan</span>
                                            <img src="/images/mydigitalid-logo.png" alt="MyDigital ID" />
                                        </a>
                                    </w-flex>
                                    <!-- Google login disabled: 'google.redirect' route not registered yet.
                                    <w-flex justify-center align-center class="mt2">
                                        <a :href="$route('google.redirect')" class="grow" style="text-decoration:none">
                                            <w-button class="my2 btn-ihasil-login grow" type="button">
                                                <w-icon class="mr2" xs>fab fa-google</w-icon>
                                                Log Masuk dengan Google
                                            </w-button>
                                        </a>
                                    </w-flex>
                                    -->
                                    <div class="login-3rd-header">
                                        Muat turun <a href="Borang Register/iHasil - Borang Permohonan ID.pdf"
                                            >Borang Pendaftaran</a
                                        > dan
                                        <inertia-link :href="$route('register')"
                                            >Daftar</inertia-link
                                        > untuk daftar pengguna
                                    </div>
                                    <div class="login-3rd-header">
                                        Klik
                                        <inertia-link
                                            :href="$route('utiliti.register')"
                                            >Di Sini</inertia-link
                                        >
                                        untuk sebarang Aduan.
                                    </div>
                                </w-form>

                                <div class="zloginbox-title-footer">
                                    Hak Cipta Terpelihara ©2022 oleh
                                    <b>Kerajaan Negeri Kedah</b>
                                </div>
                            </w-card>
                        </main>
                        <!--/-->
                    </div>
                </div>
                <div class="xs6 pa1 login-right"></div>
            </w-flex>

            <footer></footer>
        </w-app>
    </div>
</template>

<script>
import ZResource from "@/Modules/z-resource";

export default {
    extends: ZResource,
    data() {
        return {
            isPassword: true,
            loginMode: "db",
            form: {
                email: "",
                password: "",
            },
            // validators: {
            //     required: value => !!value || 'Medan Ini Wajib Isi'
            //     // Other validators...
            //   }
        };
    },
    methods: {
        attemp() {
            const url = this.loginMode === "sso" ? "login/sso" : "login";

            this.$inertia.post(url, this.form, {
                preserveState: true,
            });
        },
    },
};
</script>

<style>
/* iHASIL */

.login-ihasil .w-card {
    border: 0px;
}

.login-ihasil main {
    padding: 0px;
}

.login-header {
    margin-top: 25%;
    margin-bottom: 35px;
    font-size: 100px;
    font-weight: bold;
    background: -webkit-linear-gradient(#4b2f99, #2f50d3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background: url(/images/logo-ihasil-baru.png) no-repeat;
    background-size: contain;
}

.login-2nd-header {
    font-size: 30px;
    font-weight: bold;
    margin-top: -25px;
}
.login-3rd-header {
    font-size: 13px;
    margin-top: 0px;
    text-align: center;
    margin-top: 5px;
}
.login-main {
    padding-left: 35%;
}
.login-left {
    background: #fff;
}
.login-right {
    background: url(/images/ihasil-login-bg.png);
    background-size: cover;
    background-position: center;
}
.btn-ihasil-login {
    border-radius: 30px;
    height: 40px !important;
    font-size: 15px !important;
    font-weight: bold;
    background: -webkit-linear-gradient(#4b2f99, #2f50d3) !important;
}
.btn-mydigitalid {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
    padding: 0 14px;
    border: 2px solid #1d2939;
    border-radius: 10px;
    background: #ffffff;
    color: #1d2939;
    font-weight: bold;
    font-size: 15px;
    text-decoration: none;
    transition: background 0.15s ease, border-color 0.15s ease;
}
.btn-mydigitalid:hover {
    background: #f2f4f7;
    border-color: #1d2939;
    color: #1d2939;
}
.login-divider {
    display: flex;
    align-items: center;
    margin: 8px 0 2px;
    text-align: center;
    color: #667085;
    font-size: 13px;
    font-weight: bold;
}
.login-divider::before,
.login-divider::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #d0d5dd;
}
.btn-mydigitalid img {
    height: 22px;
    width: auto;
    display: block;
}
/* iHASIL */

#app {
    flex-direction: column;
}
.w-app {
    /*background: url(/images/sppb-login-bg.png) !important;*/
    background-size: cover !important;
    background-repeat: no-repeat !important;
}
.zloginbox {
    max-width: 420px;
    width: 100%;
    background: inherit !important;
}
.zloginbox .w-card__content {
    background: #fff;
}
.zloginbox .w-toolbar {
    background-color: #0c213ab8;
    color: #fff;
}
.zloginbox .w-input__input-wrap {
    margin-top: 25px;
}
.zloginbox .w-input__label--inside {
    font-size: 15px;
    margin-top: -5px;
    margin-left: -5px;
}
.zloginbox .w-input__input-wrap--box {
    height: 40px;
}
.zloginbox .w-card__content {
    padding: 0px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}
.w-card.zloginbox-title {
    background: #0c213ab8;
    color: #fff;
    text-align: center;
    background: #3d272ab0;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-top: 1px solid #8c6c68;
    border-left: 1px solid #8c6c68;
    border-right: 1px solid #8c6c68;
    margin-top: 150px;
}
.zloginbox-title-top {
    font-weight: bold;
    font-size: 15px;
    text-shadow: 1px 1px black;
}
.zloginbox-title-bottom {
    margin-bottom: 10px;
    margin-top: 5px;
}
.zloginbox-logo img {
    height: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.btn-zloginbox {
    color: #fff;
    background-color: #1761fd !important;
    border-color: #1761fd !important;
    font-size: 13px !important;
    padding: 15px;
}
.zloginbox-title-footer {
    text-align: center;
    font-size: 13px;
    color: #333;
    margin-top: 10px;
}
</style>